import { AI_FUNDING_MODES } from '../UniversityAiConfigurationPanel';

export const TAB_KEYS = [
  'overview',
  'universities',
  'case-transfer',
  'billing',
  'runtime-assets',
  'realtime',
  'marking',
  'compliance',
  'features',
];

export const GEMINI_REASONING_EFFORT_OPTIONS = [
  { value: 'off', label: 'Off' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const geminiLiveModelKind = (model = '') => {
  const id = String(model).trim().toLowerCase().replace(/^models\//, '');
  if (id === 'gemini-3.8-live') return 'standard38';
  if (id === 'gemini-3.8-live-extended-thinking') return 'extended38';
  return 'legacy';
};

export const geminiReasoningOptionsForModel = (model) => {
  const kind = geminiLiveModelKind(model);
  if (kind === 'standard38') return GEMINI_REASONING_EFFORT_OPTIONS.filter(({ value }) => value === 'off');
  if (kind === 'extended38') return GEMINI_REASONING_EFFORT_OPTIONS.filter(({ value }) => value !== 'minimal' && value !== 'off');
  return GEMINI_REASONING_EFFORT_OPTIONS;
};

export const effectiveGeminiReasoningEffort = (model, value) => {
  const kind = geminiLiveModelKind(model);
  if (kind === 'standard38') return 'off';
  if (kind === 'extended38' && (value === 'minimal' || value === 'off')) return 'low';
  return value;
};

export const UNITY_ADDRESSABLE_PLATFORMS = [
  { key: 'windows', label: 'PC (Windows)' },
  { key: 'macos', label: 'Mac' },
  { key: 'ios', label: 'iOS' },
  { key: 'android', label: 'Android' },
];

export const defaultAddressablesForm = UNITY_ADDRESSABLE_PLATFORMS.reduce((acc, platform) => {
  acc[platform.key] = {
    version: '',
    buildNumber: '',
    notes: '',
    file: null,
  };
  return acc;
}, {});

export const defaultAddressablesOverview = {
  builds: [],
  config: {
    bucket: '',
    prefix: '',
    publicBaseUrl: '',
    currentBaseUrls: UNITY_ADDRESSABLE_PLATFORMS.reduce((acc, platform) => {
      acc[platform.key] = '';
      return acc;
    }, {}),
  },
};

export const defaultVoiceSamplesOverview = {
  providers: ['openai', 'gemini'],
  voices: {
    openai: [],
    gemini: [],
  },
  samples: {
    openai: [],
    gemini: [],
  },
  counts: {
    openai: 0,
    gemini: 0,
    total: 0,
  },
};

export const defaultVoiceSampleForm = {
  provider: 'openai',
  voice: '',
  file: null,
};

export const defaultCreateFormState = {
  name: '',
  code: '',
  slug: '',
  seatCapacity: 0,
  status: 'active',
  contactEmail: '',
  contactPhone: '',
};

export const defaultBillingForm = {
  freeSignupTokens: 3,
  historyCostTokens: 1,
  userRegistrationCap: 0,
  receiptsEnabled: true,
  vatInvoicesEnabled: true,
  refundPolicy: '',
  refundWindowDays: 14,
  ps5WalletMode: 'platform-isolated',
  ps5SonyApprovalReference: '',
  ps5SonyApprovedAt: '',
  ps5TenantAccessMode: 'blocked',
  ps5TenantApprovalReference: '',
  ps5TenantApprovedAt: '',
  tokenPacks: [],
};

export const defaultPilotForm = {
  enabled: true,
};

export const defaultRealtimeForm = {
  provider: 'openai',
  parentApiKey: '',
  realtimeModel: '',
  voice: '',
  proactiveAudio: false,
  affectiveDialog: false,
  allowInterruptions: false,
  toolCallingEnabled: true,
  reasoningEffort: 'off',
  contextWindowCompressionEnabled: true,
  contextWindowCompressionTriggerTokens: '',
  contextWindowCompressionTargetTokens: '',
  azureEndpoint: '',
  azureApiKey: '',
};

export const defaultMarkingForm = {
  provider: 'openai',
  parentApiKey: '',
  markingModel: '',
  azureEndpoint: '',
  azureDeploymentId: '',
  azureApiVersion: '',
  azureResourceName: '',
  azureApiKey: '',
  azureUseActiveDirectory: false,
  parameters: {
    temperature: '0',
    maxOutputTokens: '',
    topP: '',
    frequencyPenalty: '',
    presencePenalty: '',
    reasoningEffort: '',
    verbosity: 'medium',
  },
};

export const defaultTranscriptionForm = {
  enabled: false,
  provider: 'openai',
  parentApiKey: '',
  model: 'gpt-4o-transcribe',
  azureEndpoint: '',
  azureDeploymentId: '',
  azureApiVersion: '',
  azureResourceName: '',
  azureApiKey: '',
  azureUseActiveDirectory: false,
};

export const defaultUniversityAiForm = {
  funding: {
    mode: AI_FUNDING_MODES.PLATFORM_WALLET,
  },
  realtime: {
    ...defaultRealtimeForm,
    useGlobalCredentials: true,
  },
  marking: {
    ...defaultMarkingForm,
    useGlobalCredentials: true,
  },
  transcription: {
    ...defaultTranscriptionForm,
    useGlobalCredentials: true,
  },
};
